import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cold",
  "description": "",
  "published": "2006-12-14T00:00:00.000Z",
  "redirect_from": ["/blog/cold/swizec/346"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yes, it got cold outside, last week the average temperature was 15°C and now this week around 0°C ... thank you global warming, we love you man. But seriously, I very much love cold, there's just something about it that is so very much better than heat. Maybe it's all the fun I derive from being properly clad, or maybe it's that I don't get my eyes poked out by boobies wherever they turn. Yes, severe cold, that's just bad and unenjoyable, it usually also hurts.`}</p>
    <p>{`There are some unique problems related to col, though, that are not apparent in warmness. There is for example the ever looming, low to the ground, winter sun ... that thing is just annoying with it's desire to kill people's eyes, why, why do you have to do it you silly thing! Another is the fact that my favourite tea procuring building is always full, especially when I want to go in for a cup. See, I love tea, and I do great work at tea shops, but it's difficult to do when there is nowhere to sit down and actually have that tea. Stupid too small place.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      